import PlanCuentasEditModal from "./PlanCuentasEditModal";
export default PlanCuentasEditModal;